import { I18n } from 'react-redux-i18n';

function priorityStatus(status) {
  switch (status) {
    case 0:
      return I18n.t('BEE2492' /* Desativado */);
    case 1:
      return I18n.t('BEE499' /* Ativo */);
    default:
      return status;
  }
}

function listPriorityStatus() {
  return [
    { value: 0, label: I18n.t('BEE2492' /* Desativado */) },
    { value: 1, label: I18n.t('BEE499' /* Ativo */) },
  ];
}

function statusPriority(status = null) {
  if (status === 0 || status === 1) {
    switch (status) {
      case 0:
        return I18n.t('BEE2492' /* Desativado */);
      case 1:
        return I18n.t('BEE4046' /* Ativado */);
      default:
        return status;
    }
  }

  return [
    { value: 1, label: I18n.t('BEE4046' /* Ativado */) },
    { value: 0, label: I18n.t('BEE2492' /* Desativado */) },
  ];
}

export default {
  priorityStatus,
  listPriorityStatus,
  statusPriority,
};
